// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CheckCircleTwoToneSvg from "@fishx/icons-svg/es/asn/CheckCircleTwoTone";
import FishxIcon from '../components/FishxIcon';

var CheckCircleTwoTone = function CheckCircleTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CheckCircleTwoToneSvg
  }));
};

CheckCircleTwoTone.displayName = 'CheckCircleTwoTone';
export default React.forwardRef(CheckCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CheckCircleTwoTone.js
// module id = 2196
// module chunks = 0